
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const entities = state => state.data.entities;
const projects = state => state.projects;
const getsingle = state => param =>state.projects.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  projects,
  getsingle,
  entities
};